import React from 'react';
import { PaymentElement } from '@stripe/react-stripe-js';

export const StripeElement = (): JSX.Element => <PaymentElement />;

export default StripeElement;
